import { gql } from "apollo-boost"

export const getConcepts = gql`
  query Concepts($id: ID!) {
    Concepts(id: $id) {
      id
      name
      index
      type
      unitCost
      totalUnits
      budgeted
      monthlyDistributionHours
      hours
      humanResource {
        id
        position
        isBlocking
        isBlockinginHumanResource
        name        
        hours
        contractType        
        benefits     
        phone
        rfc
        email
        identifiedConsultant
        documents {
          id
          name
          url
          type
        }
        positionDocs {
          id
          name
          url
          type
        }
      }
    }
  }
`
